// extracted by mini-css-extract-plugin
export default {"button":"_q-z","reviewSort":"ar-z"};